<template>
    <nav>
        <ul :style="{'--size': linkSize}">
            <router-link
              v-for="(link, index) in filteredMenu"
              :key="index" tag="li"
              :to="{name: link.name, params:{ icon: link.icon }}"
              :exact="link.name === 'home'">
                <component :is="icons[link.icon]"></component>{{ link.title }}
            </router-link>
        </ul>
    </nav>
</template>

<script type="text/babel">
import icons from '../assets/icons';

export default {
  data() {
    return {
      icons,
    };
  },
  computed: {
    filteredMenu() {
      return Object.values(this.$config.navigation)
        .filter((link) => !link.disabled)
        .sort((a, b) => Math.sign(a.pos - b.pos));
    },
    linkSize() {
      const itemCount = this.filteredMenu.length;
      return [
        [0, '7.5em'],
        [4, '7.5em'],
        [5, '7em'],
        [6, '6.5em'],
      ].filter(([size]) => itemCount > size).slice(-1)[0][1];
    },
  },
};

export const routes = {
  events: {
    id: 'events',
    title: 'Termine',
    name: 'events',
    icon: 'date',
    pos: 0,
  },
  news: {
    id: 'news',
    title: 'Aktuelles',
    name: 'news',
    icon: 'news',
    pos: 1,
  },
  machines: {
    id: 'machines',
    title: 'Maschinen',
    name: 'machines',
    icon: 'tractor',
    pos: 2,
  },
  offers: {
    id: 'offers',
    title: 'Angebote',
    name: 'offers',
    icon: 'shop',
    pos: 3,
  },
  gallery: {
    id: 'gallery',
    title: 'Galerie',
    name: 'gallery',
    icon: 'gallery',
    pos: 4,
  },
  home: {
    id: 'home',
    title: 'Start',
    name: 'home',
    icon: 'home',
    pos: 5,
  },
};
</script>

<style lang="scss">
    nav {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        margin-top: 1em;
        padding: 0 1.5em;
        ul {
            --size: 7.5em;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            flex-grow: 1;
            padding: 0;
            margin: 0;
            li {
                width: var(--size);
                height: var(--size);
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                font-weight: 700;
                font-size: 1.25em;
                /*background: var(--accent-color);*/
                color: #222;
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.22);
                border-radius: 4px;
                padding: 1em;
                &.router-link-active {
                    $color: var(--accent-color-text);
                    background:
                      linear-gradient(to right, var(--gradient-color-1), var(--gradient-color-2));
                    color: $color;
                    svg {
                        g[stroke] {
                            stroke: $color;
                        }
                        path:not([fill="none"]) {
                            fill: $color;
                        }
                        path[fill="none"] {
                            stroke: $color;
                        }
                        circle[fill="none"] {
                            stroke: $color;
                        }
                    }
                }
            }
        }
    }
</style>
